import { useState } from "react";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import { gallery } from "../data/gallery";
import "yet-another-react-lightbox/styles.css";
import HeroSlider from "../Components/HeroSlider";
import SupportBanner from "../Components/SupportBanner";

const categories = ["Mind", ...new Set(gallery.map((g) => g.category))];

export default function GalleryPage() {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [filter, setFilter] = useState("Mind");

const heroImages = [
  "./images/image8.jpg",
  "./images/image21.JPG",
  "./images/image24.JPG",
  "./images/image14.jpg",
  "./images/image30.JPG",
  "./images/image32.JPG",
];

  const photos = gallery
    .filter((g) => filter === "Mind" || g.category === filter)
    .map((g) =>
      g.type === "video"
        ? { ...g, width: 16, height: 9 }
        : g
    );

  return (
    <><HeroSlider images={heroImages} /><main className="mx-auto max-w-7xl px-4 py-12">
          <h1 className="mb-8 text-center text-4xl font-bold">Galéria</h1>

          {/* kategória filter */}
          <div className="mb-10 flex flex-wrap justify-center gap-4">
              {categories.map((c) => (
                  <button
                      key={c}
                      onClick={() => setFilter(c)}
                      className={`rounded-md px-4 py-1 text-sm ${c === filter
                              ? "bg-primary text-white"
                              : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                  >
                      {c}
                  </button>
              ))}
          </div>

          {/* fotóalbum */}
          <PhotoAlbum
              layout="rows"
              photos={photos}
              spacing={8}
              onClick={({ index }) => {
                  setIndex(index);
                  setOpen(true);
              } } />

          <Lightbox
              open={open}
              close={() => setOpen(false)}
              index={index}
              slides={photos.map((p) => p.type === "video"
                  ? {
                      type: "video",
                      width: 1280,
                      height: 720,
                      sources: [{ src: p.src }],
                  }
                  : p.type === "youtube"
                      ? {
                          type: "video",
                          width: 1280,
                          height: 720,
                          sources: [{ src: p.src }],
                          poster: "/gallery/youtube_placeholder.jpg",
                      }
                      : { src: p.src }
              )}
              plugins={[Video]} />
      </main>
      <SupportBanner /></>
  );
}
